<template>
<!--  <div id="map" style="position:absolute;width:500px; height:400px"></div>-->
  <div id="map" style="width: 445px;height: 269px"></div>
</template>

<script setup>
import {ref} from "vue";

const skyMap = ref(null);

onMounted(() => {
  let map = new T.Map('map');
  let latlng = new T.LngLat(113.57537806034088,34.71900265663862)
  map.centerAndZoom(latlng, 18);
  var label = new T.Label({
    text: "郑州路桥建设投资集团有限公司",
    position: latlng,
    offset: new T.Point(-9, 0)
  });
  //创建地图文本对象
  map.addOverLay(label);
  // 113.58,34.72

})

</script>

<style scoped lang="scss">

</style>